import "./PasswordValidator.css";

import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface PasswordValidatorProps {
  password: string;
  newPassword: string;
}
const PasswordValidator = ({ password, newPassword }: PasswordValidatorProps) => {
  const [passwordRule1Valid, setPasswordRule1Valid] = useState<boolean>(false);
  const [passwordRule2Valid, setPasswordRule2Valid] = useState<boolean>(false);
  const [passwordRule3Valid, setPasswordRule3Valid] = useState<boolean>(false);
  const [passwordRule4Valid, setPasswordRule4Valid] = useState<boolean>(false);
  const [passwordRule5Valid, setPasswordRule5Valid] = useState<boolean>(false);
  const [passwordRule6Valid, setPasswordRule6Valid] = useState<boolean>(false);

  useEffect(() => {
    if (password && password?.trim().length >= 8) {
      setPasswordRule1Valid(true);
    } else {
      setPasswordRule1Valid(false);
    }
    if (/[A-Z]/.test(password?.trim()!)) {
      setPasswordRule2Valid(true);
    } else {
      setPasswordRule2Valid(false);
    }
    if (/[a-z]/.test(password?.trim()!) && password) {
      setPasswordRule3Valid(true);
    } else {
      setPasswordRule3Valid(false);
    }
    if (/[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(password?.trim()!)) {
      setPasswordRule4Valid(true);
    } else {
      setPasswordRule4Valid(false);
    }
    if (/\d/.test(password?.trim()!)) {
      setPasswordRule5Valid(true);
    } else {
      setPasswordRule5Valid(false);
    }
    if (password && newPassword && password.trim() === newPassword.trim()) {
      setPasswordRule6Valid(true);
    } else {
      setPasswordRule6Valid(false);
    }
  }, [password, newPassword]);
  return (
    <div className="password-validator-container">
      <p className="password-guidelines-heading">Passwords must:</p>
      <div className="password-guidelines-container">
        <div>
          <FontAwesomeIcon
            style={{
              visibility: passwordRule1Valid ? "visible" : "hidden",
            }}
            icon={faCheck}
            size="1x"
            color="green"
          />
          Be a minimum length of 8 characters
        </div>
        <div>
          <FontAwesomeIcon
            style={{
              visibility: passwordRule2Valid ? "visible" : "hidden",
            }}
            icon={faCheck}
            size="1x"
            color="green"
          />
          Include at least one upper case letter (A-Z)
        </div>
        <div>
          <FontAwesomeIcon
            style={{
              visibility: passwordRule3Valid ? "visible" : "hidden",
            }}
            icon={faCheck}
            size="1x"
            color="green"
          />
          Include at least one lower case alphabet letter (a-z)
        </div>
        <div>
          <FontAwesomeIcon
            style={{
              visibility: passwordRule4Valid ? "visible" : "hidden",
            }}
            icon={faCheck}
            size="1x"
            color="green"
          />
          Include at least one special character
        </div>
        <div>
          <FontAwesomeIcon
            style={{
              visibility: passwordRule5Valid ? "visible" : "hidden",
            }}
            icon={faCheck}
            size="1x"
            color="green"
          />
          Include at least one number (0-9)
        </div>
        <div>
          <FontAwesomeIcon
            style={{
              visibility: passwordRule6Valid ? "visible" : "hidden",
            }}
            icon={faCheck}
            size="1x"
            color="green"
          />
          Passwords must match
        </div>
      </div>
    </div>
  );
};

export default PasswordValidator;
